import { getUserInfo, getUserApply } from "@/api/platform";

export default {
  namespaced: true,
  state: {
    userInfo: null,
  },
  getters: {
    getUserInfo: (state) => state.userInfo,
  },
  mutations: {
    setUserInfo(state, payload) {
      state.userInfo = payload;
    },
  },
  actions: {
    async getUserInfoAction({ commit }) {
      const { results } = await getUserInfo();
      // 用户认证状态
      const { results: res2 } = await getUserApply();
      results.applyStatus = res2.status;
      commit("setUserInfo", results);
    },
    async logout({ commit }) {
      localStorage.clear();
      sessionStorage.clear();
      commit("setUserInfo", null);
    },
  },
};
